import React, { ComponentType, useState, useEffect } from 'react';
import { documents$ } from '../services/subjects';
import documentService from '../services/documentService';
import { map, tap, switchMap, filter, first } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { DocumentHeader } from 'types/documents/DocumentHeader';

export type WithDocumentDataState = {
    documents: DocumentHeader[],
    loadingDocuments: boolean;
};

export default function withDocumentData(WrappedComponent: ComponentType<WithDocumentDataState & any>) {
    return function WithDocumentDataWrapper(props: any) {
        const [documents, setDocuments] = useState<DocumentHeader[]>([]);
        const [loadingDocuments, setLoadingDocuments] = useState<boolean>(true);

        useEffect(() => {
            const fetchDocumentsFromServer$ = documentService.get$.pipe(
                filter((response) => !!response.response),
                map((response) => response.response.results),
                tap((documents) => documents$.next(documents)),
                first(),
            );

            const subscription: Subscription = documents$
                .pipe(
                    switchMap((document) =>
                        document === null ? fetchDocumentsFromServer$ : of(document)
                    )
                )
                .subscribe({
                    next: (documents) => {
                        setDocuments(documents);
                        setLoadingDocuments(false);
                    },
                    error: () => {
                        setLoadingDocuments(false);
                    },
                });

            // Cleanup subscription on unmount
            return () => subscription.unsubscribe();
        }, []);
        
        return (
            <WrappedComponent
                documents={documents}
                loadingDocuments={loadingDocuments}
                {...props}
            />
        );
    };
}
